import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ListApprovedModal from "./ListApprovedModal";
import AddMultiRespModal from "./AddMultiResponsibilitiesModal";
import {
  LdsButton,
  useLdsModal,
  LdsModal,
  LdsLink,
  LdsIcon,
  LdsCard,
  LdsBadge,
  LdsSearch,
  useToastContext,
  LdsTable,
  LdsCheckbox,
  LdsPagination,
} from "@elilillyco/ux-lds-react";
import {
  UPDATE_SPECIALITYLIST,
  UPDATE_LIST_PARTICIPANTS,
  SET_RESP_INDEX,
  SET_SPECIALITY_LIST,
} from "../../store/details";
import { FETCH_USER_LIST } from "../../store/admin";
import { useEffect, useRef, useState } from "react";
import "../../assets/scss/details/details.scss";
import exportExcelSheet from "../../utils/overview/exportExcelSheet";
import EditBrandIndication from "../details/EditBrandIndication";
import infoToastConfig from "../shared/Toast";
import SearchResponsibilityModal from "../details/SearchResponsibilityModal";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import EditParticipantsModal from "./EditParticipantsModal";
import SortableHeader from "../shared/SortableHeader";
import StepTracker from "../shared/StepTracker";
import sendReminder from "../../api/overview/sendReminder";
import { lockSpecialtyList } from "../../api/details/index";
import ctx, { getToken } from "../../plugins/axios";

const pageSize = 10;

const isSalesforceList = (list) =>
  Boolean(list?.list_quarter && list.list_quarter.trim() !== "");

const OverviewTable = ({
  showAddedSpecialties,
  selectedValues,
  setselectedValues,
  visibleSpecialties,
  setVisibleSpecialties,
}) => {
  const {
    isModalOpen: isListAppModalOpen,
    setIsModalOpen: setListAppModalOpen,
  } = useLdsModal();
  const { isModalOpen: isRespModalOpen, setIsModalOpen: setIsRespModalOpen } =
    useLdsModal();
  const { isModalOpen: isDelModalOpen, setIsModalOpen: setIsDelModalOpen } =
    useLdsModal();
  const { isModalOpen: isInfoModalOpen, setIsModalOpen: setIsInfoModalOpen } =
    useLdsModal();
  const dispatch = useDispatch();
  const { isModalOpen, setIsModalOpen } = useLdsModal();
  const { addToast } = useToastContext();

  const [editBrandIndication, seteditBrandIndication] = useState(false);
  const [searchText, setsearchText] = useState("");
  const [respmode, setrespmode] = useState("");

  const [msg, setMsg] = useState("");
  const [deleteMultipleSpecialties, setdeleteMultipleSpecialties] =
    useState(false);
  const [delSpeclIndex, setdelSpeclIndex] = useState("");
  const [updateResCodeIndex, setupdateResCodeIndex] = useState("");
  const [addedSpecialtyCodes, setAddedSpecialtyCodes] = useState([]);
  const [uncommonRespCodes, setUncommonRespCodes] = useState([]);
  const [delSpecialtyCodes, setDelSpecialtyCodes] = useState([]);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(pageSize);

  // Cooldown state for reminder button
  const [remindCooldowns, setRemindCooldowns] = useState({});

  // Lock state: null = unlocked, object = { locked_by, locked_at } held by another user
  const [lockInfo, setLockInfo] = useState(null);
  const [lockLoading, setLockLoading] = useState(false);
  const holdsLockRef = useRef(false); // tracks whether THIS user currently holds the lock
  const lockInfoRef = useRef(null); // mirrors lockInfo state for stale-closure-safe reads inside setInterval
  const isUnlockingRef = useRef(false); // suppresses polling during unlock to prevent race condition
  // Edit Participants modal state
  const [isEditParticipantsOpen, setIsEditParticipantsOpen] = useState(false);

  const userRole = sessionStorage.getItem("role") || "";

  const {
    specialtyList,
    responsibilityList,
  } = useSelector(({ details }) => details);
  const { uuid, emailId, brands } = useSelector(({ user }) => user);
  const { userTableList } = useSelector(({ admin }) => admin);

  let useruuids = userTableList
    .filter((value) => value.email_id === emailId && value.active === true)
    .map((value) => value.uuid);

  // Get the UUID for the CURRENT role (not just any role the user has)
  const currentRoleUuid = userTableList
    .find((user) => user.email_id === emailId && user.role === userRole && user.active === true)
    ?.uuid || uuid;

  const buildLockMessage = (lockData) => {
    const lockerUser = userTableList.find((user) => user.uuid === lockData?.locked_by);
    const lockerName = lockerUser
      ? `${lockerUser.first_name || ""} ${lockerUser.last_name || ""}`.trim() || lockerUser.email_id
      : "Another user";
    const lockedSince = lockData?.locked_at
      ? new Date(lockData.locked_at).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
      : null;

    return lockedSince
      ? `${lockerName} is currently editing this list (since ${lockedSince}). Please try again later.`
      : `${lockerName} is currently editing this list. Please try again later.`;
  };

  /**
   * Fetch current lock status from backend without attempting to acquire/release
   * Used to refresh lock state and detect stale frontend state
   */
  const fetchLockStatus = async () => {
    if (!specialtyList?.uuid) return null;
    try {
      const response = await ctx.get(`/specialty_list/${specialtyList.uuid}`);
      const listData = response.data?.data || {};
      return {
        locked_by: listData.locked_by || "",
        locked_at: listData.locked_at || "",
      };
    } catch (err) {
      console.warn("Failed to fetch lock status:", err);
    }
    return null;
  };

  /**
   * Attempt to acquire the edit lock for this list.
   * Lock is only used for Salesforce lists (list_quarter set).
   * Returns true if the lock was acquired (or not needed), false if another user holds it.
   */
  const lockList = async () => {
    // Locking applies only to Salesforce lists (lists with list_quarter set)
    if (!isSalesforceList(specialtyList)) return true;
    if (!specialtyList?.uuid || lockLoading) return false;
    setLockLoading(true);
    try {
      await lockSpecialtyList({
        listUUID: specialtyList.uuid,
        lockPayload: {
          locked_by: currentRoleUuid || uuid,
          locked_at: new Date().toISOString().replace('T', ' ').split('.')[0],
          updated_by: currentRoleUuid || uuid,
        },
      });
      setLockInfo(null);
      lockInfoRef.current = null;
      holdsLockRef.current = true;
      return true;
    } catch (err) {
      if (err?.response?.status === 423) {
        const data = err.response.data?.data || {};
        setLockInfo(data);
        lockInfoRef.current = data;
        const msg = buildLockMessage(data);
        addToast(infoToastConfig(msg, "error", 6000));
        return false;
      }
      // Any other error acquiring a lock should block editing.
      // Otherwise users (including admin) can enter edit mode without actually holding the lock.
      addToast(
        infoToastConfig(
          err?.response?.data?.message || "Unable to acquire edit lock. Please try again.",
          "error",
          6000
        )
      );
      return false;
    } finally {
      setLockLoading(false);
    }
  };

  /**
   * Release the edit lock.
   * Called on Cancel, Save, and component unmount.
   * Lock operations apply only to Salesforce lists. MLR lists are collaborative (no locking).
   * After releasing, verify the unlock succeeded by fetching current lock status.
   */
  const unlockList = async (isForce = false) => {
    // Lock functionality is only for Salesforce lists
    if (!isSalesforceList(specialtyList)) return false;
    if (!specialtyList?.uuid) return false;
    // Only release the lock if THIS user holds it, unless it's an explicit admin force unlock
    if (!isForce && !holdsLockRef.current) return false;
    isUnlockingRef.current = true;
    try {
      await lockSpecialtyList({
        listUUID: specialtyList.uuid,
        lockPayload: {
          locked_by: "",
          locked_at: "",
          updated_by: currentRoleUuid || uuid,
        },
      });
      // Trust the 200 from PUT — DynamoDB eventual consistency means a GET
      // immediately after PUT can return stale data and falsely show lock still held.
      setLockInfo(null);
      lockInfoRef.current = null;
      holdsLockRef.current = false;
      return true;
    } catch (err) {
      console.warn("unlockList failed:", err);
      return false;
    } finally {
      isUnlockingRef.current = false;
    }
  };

  /**
   * Admin/Super Admin force unlock — single-click with confirmation.
   * Only applies to Salesforce lists (MLR lists have no locking).
   */
  const handleForceUnlock = async () => {
    if (!window.confirm("The user currently editing may lose unsaved changes. Are you sure you want to unlock this list?")) return;
    const success = await unlockList(true);
    if (success) {
      addToast(infoToastConfig("Lock released successfully.", "success", 5000));
    } else {
      addToast(infoToastConfig("Failed to release lock. Please try again.", "error", 5000));
    }
  };
 
  const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

  // Cache a fresh MSAL token for use in the beforeunload keepalive fetch
  const latestTokenRef = useRef(null);
  useEffect(() => {
    const refreshToken = async () => {
      const token = await getToken();
      if (token) latestTokenRef.current = token;
    };
    refreshToken();
    const interval = setInterval(refreshToken, 4 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!holdsLockRef.current || !specialtyList?.uuid) return;
      const callerUUID = currentRoleUuid || uuid;
      ctx.put(`/specialty_list_heartbeat/${specialtyList.uuid}`, { updated_by: callerUUID })
        .catch(() => {}); // best-effort, don't block the user
    }, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialtyList?.uuid]);
  
  // CRITICAL FIX: Polling mechanism to detect concurrent lock state changes
  // Periodically refresh lock status to keep frontend in sync with backend
  // This prevents the race condition where another user's unlock is not visible
  const LOCK_POLL_INTERVAL_MS = 3000; // 3 seconds
  useEffect(() => {
    if (!isSalesforceList(specialtyList) || !specialtyList?.uuid) return;
    
    const interval = setInterval(async () => {
      // Only poll if we don't hold the lock and no unlock is in progress
      if (holdsLockRef.current || isUnlockingRef.current) return;
      
      const currentLockStatus = await fetchLockStatus();
      if (!currentLockStatus) return;
      
      const currentUuid = currentRoleUuid || uuid;
      const isStillLockedByOther = currentLockStatus.locked_by && currentLockStatus.locked_by !== currentUuid;
      const wasLockedByOther = lockInfoRef.current && lockInfoRef.current.locked_by;

      // Detect lock release: was locked, now unlocked
      if (wasLockedByOther && !isStillLockedByOther) {
        console.info("Detected lock release - list is now available for editing");
        setLockInfo(null);
        lockInfoRef.current = null;
        addToast(infoToastConfig("List is now available for editing.", "success", 3000));
      }
      // Detect lock acquisition: was unlocked, now locked by someone else
      else if (!wasLockedByOther && isStillLockedByOther) {
        console.info("Detected lock acquisition by another user");
        setLockInfo(currentLockStatus);
        lockInfoRef.current = currentLockStatus;
        const lockerUser = userTableList.find((u) => u.uuid === currentLockStatus.locked_by);
        const lockerName = lockerUser
          ? `${lockerUser.first_name || ""} ${lockerUser.last_name || ""}`.trim() || lockerUser.email_id
          : "Another user";
        addToast(infoToastConfig(`${lockerName} started editing this list. Your changes are now locked.`, "warning", 4000));
      }
      // Detect lock holder change: locked by different user
      else if (wasLockedByOther && isStillLockedByOther && currentLockStatus.locked_by !== lockInfoRef.current?.locked_by) {
        console.info("Lock transferred to different user");
        setLockInfo(currentLockStatus);
        lockInfoRef.current = currentLockStatus;
        const lockerUser = userTableList.find((u) => u.uuid === currentLockStatus.locked_by);
        const lockerName = lockerUser
          ? `${lockerUser.first_name || ""} ${lockerUser.last_name || ""}`.trim() || lockerUser.email_id
          : "Another user";
        addToast(infoToastConfig(`${lockerName} is now editing this list.`, "info", 3000));
      }
    }, LOCK_POLL_INTERVAL_MS);
    
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialtyList?.uuid]);
  
  
  // Release lock when navigating away from the details page
  useEffect(() => {
    // Handler for tab close / browser refresh — async unlockList() won't
    // complete in time, so use fetch with keepalive which survives page unload.
    const handleBeforeUnload = () => {
      if (!holdsLockRef.current) return; // only release if WE hold the lock
      holdsLockRef.current = false;
      const listUUID = specialtyList?.uuid;
      const callerUUID = currentRoleUuid || uuid;
      if (!listUUID || !callerUUID || !isSalesforceList(specialtyList)) return;
      const baseURL = ctx.defaults.baseURL || "";
      const token = latestTokenRef.current || "";
      fetch(`${baseURL}/specialty_list/${listUUID}`, {
        method: "PUT",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ locked_by: "", locked_at: "", updated_by: callerUUID }),
      });
    };
 
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (holdsLockRef.current) {
        unlockList();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialtyList?.uuid]);

  /**
   * Check if cooldown is active for a given status
   */
  const isCooldownActive = (status) => {
    const cooldownInfo = remindCooldowns[status];
    if (!cooldownInfo || !cooldownInfo.cooldown_until) return false;
    
    const now = new Date();
    const cooldownUntil = new Date(cooldownInfo.cooldown_until);
    return now < cooldownUntil;
  };

  const handleRemind = async (stepStatus) => {
    if (!specialtyList?.uuid) return;
    setIsInfoModalOpen(false);
    try {
      const response = await sendReminder({
        uuid: specialtyList.uuid,
        current_status: stepStatus,
      });

      // Update cooldown state if backend returns cooldown info
      if (response.data?.data?.cooldown_until) {
        setRemindCooldowns(prev => ({
          ...prev,
          [stepStatus]: {
            cooldown_until: response.data.data.cooldown_until,
            hours_remaining: response.data.data.hours_remaining
          }
        }));
      }

      addToast(
        infoToastConfig("Reminder email sent successfully!", "success")
      );
    } catch (err) {
      // Handle cooldown error (429 status)
      if (err?.response?.status === 429 && err?.response?.data?.data?.cooldown_until) {
        setRemindCooldowns(prev => ({
          ...prev,
          [stepStatus]: {
            cooldown_until: err.response.data.data.cooldown_until,
            hours_remaining: err.response.data.data.hours_remaining
          }
        }));
      }

      addToast(
        infoToastConfig(
          err?.response?.data?.message || "Failed to send reminder email.",
          "error"
        )
      );
    }
  };
  useEffect(() => {
    dispatch(FETCH_USER_LIST());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // Helper function to check if current user is the list creator or admin
  const isCreatorOrAdmin = () => {
    const isAdmin = userRole === "spclty_hub_admin" || userRole === "spclty_hub_super_admin";
    
    // Check by email_id since users can have multiple UUIDs (one per role)
    // specialtyList.created_by can be either a UUID string or an object with email_id
    const creatorEmailId = typeof specialtyList?.created_by === 'object' 
      ? specialtyList?.created_by?.email_id 
      : null;
    
    const creatorUuid = typeof specialtyList?.created_by === 'object'
      ? specialtyList?.created_by?.uuid
      : specialtyList?.created_by;
    
    // CRITICAL FIX: Check if the CURRENT role's UUID matches creator UUID
    // (not just any UUID the user has)
    const isCreatorByCurrentRole = creatorUuid && creatorUuid === currentRoleUuid;
    
    // Fallback: Check by email_id for backwards compatibility with old lists
    const isCreatorByEmail = creatorEmailId && creatorEmailId === emailId;
    const isCreator = isCreatorByCurrentRole || isCreatorByEmail;
    
    return isAdmin || isCreator;
  };
  
  // Check if the current HCP SF Marketer has access to this Salesforce list,
  // allowing cross-user editing of DRAFT SF lists by list type:
  // - brnd&ind => brand
  // - thpc&dsst&mdpr => molecule
  // - thpconly / thpc&dsst => thpc
  const hasSharedBrandAccess = () => {
    if (userRole !== "spclty_hub_hcp_sf_marketer") return false;
    const userAccessStr = brands?.[userRole] || "";
    if (!userAccessStr) return false;

    const userAccessList = userAccessStr
      .split(",")
      .map((v) => v.trim().toUpperCase())
      .filter(Boolean);

    const listType = (specialtyList?.list_type || "").trim().toLowerCase();

    // Fallback values handle historical data where list_type may be missing.
    const brandValue = (specialtyList?.brand_nm || specialtyList?.brand || "")
      .trim()
      .toUpperCase();
    const moleculeValue = (specialtyList?.mdpr_nm || "").trim().toUpperCase();
    const thpcValue = (specialtyList?.thpc_nm || "").trim().toUpperCase();

    if (listType === "brnd&ind") {
      return Boolean(brandValue && userAccessList.includes(brandValue));
    }

    if (listType === "thpc&dsst&mdpr") {
      return Boolean(moleculeValue && userAccessList.includes(moleculeValue));
    }

    if (listType === "thpconly" || listType === "thpc&dsst") {
      return Boolean(thpcValue && userAccessList.includes(thpcValue));
    }

    // Safe fallback for older records without list_type.
    return Boolean(
      (brandValue && userAccessList.includes(brandValue)) ||
        (moleculeValue && userAccessList.includes(moleculeValue)) ||
        (thpcValue && userAccessList.includes(thpcValue))
    );
  };

  // Helper function to check if user has EDIT access to this list's department
  // NOTE: This does NOT block VIEWING - users can view all lists
  // This only restricts EDITING (title, metadata, routing, add/delete specialty codes)
  const hasDepartmentAccess = () => {
    // Admin and Super Admin have access to all departments
    if (userRole === "spclty_hub_admin" || userRole === "spclty_hub_super_admin") {
      return true;
    }
    
    const listDepartment = specialtyList?.department_field;
    const isSalesforceList = specialtyList?.list_quarter && specialtyList.list_quarter.trim() !== '';
    
    // Department restrictions apply ONLY to MLR lists (lists without list_quarter)
    // Salesforce lists can be edited by their respective roles regardless of department
    
    // HCP SF Marketer (Salesforce lists) - can edit ANY Salesforce list regardless of department
    if (userRole === "spclty_hub_hcp_sf_marketer") {
      return isSalesforceList; // No department restriction for Salesforce lists
    }
    
    // Incentivized Approver can access all lists (Salesforce, MLR, all departments)
    if (userRole === "spclty_hub_incentivized_approver") {
      return true; // No restrictions - can access all lists
    }
    
    // Medical Omnichannel Advisor can only EDIT Medical department MLR lists
    if (userRole === "spclty_hub_omnichannel_advisor") {
      const hasAccess = listDepartment?.toUpperCase() === "MEDICAL";
      return hasAccess;
    }
    
    // HCP Marketer can only EDIT Commercial department MLR lists (RETAIL but NOT Salesforce)
    if (userRole === "spclty_hub_hcp_marketer") {
      const hasAccess = listDepartment?.toUpperCase() === "RETAIL" && !isSalesforceList;
      return hasAccess;
    }
    
    // MLR Reviewer and MLR Approver can access any department (they review/approve all)
    if (userRole === "spclty_hub_mlr_reviewer" || userRole === "spclty_hub_mlr_approver") {
      return true;
    }
    
    // BIA team and Viewer have read-only access to all
    if (userRole === "spclty_hub_bia_team" || userRole === "spclty_hub_viewer") {
      return true;
    }
    
    // Default: deny EDIT access (but still allow viewing)
    return false;
  };
  
  useEffect(() => {
    setTotalPages(
      Math.ceil(
        visibleSpecialties?.specialties?.filter((specialty) => specialty.show)
          .length / pageSize
      )
    );
  }, [visibleSpecialties, showAddedSpecialties]);

  // Seed the lock banner from the loaded specialtyList (e.g. locked by a previous session).
  // Lock functionality applies ONLY to Salesforce lists. MLR lists are fully collaborative.
  useEffect(() => {
    const currentUuid = currentRoleUuid || uuid;
    const lockedBy = specialtyList?.locked_by;
    // Show banner only for Salesforce lists (any user can see who's editing)
    if (isSalesforceList(specialtyList) && lockedBy && lockedBy !== currentUuid) {
      const lockData = { locked_by: lockedBy, locked_at: specialtyList?.locked_at || "" };
      setLockInfo(lockData);
      lockInfoRef.current = lockData;
      // Show toast so user knows immediately without having to click Edit
      const lockerUser = userTableList.find((u) => u.uuid === lockedBy);
      const lockerName = lockerUser
        ? `${lockerUser.first_name || ""} ${lockerUser.last_name || ""}`.trim() || lockerUser.email_id
        : "Another user";
      const lockedSince = specialtyList?.locked_at
        ? new Date(specialtyList.locked_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        : null;
      const msg = lockedSince
        ? `${lockerName} is currently editing this list (since ${lockedSince}). Editing is disabled.`
        : `${lockerName} is currently editing this list. Editing is disabled.`;
      addToast(infoToastConfig(msg, "warning", 6000));
    } else {
      setLockInfo(null);
      lockInfoRef.current = null;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialtyList?.locked_by]);
  

  const thead = [
    "Specialty Code",
    "Specialty Description",
    "Sales Force Approved (Incentivized)",
    "Responsibility Code",
    "",
  ];
  const theadSf = ["Specialty Code", "Specialty Description", ""];
  const CheckViewerRole = () => {
    // Only Viewer role cannot export - all other roles including BIA Team can export
    if (userRole === "spclty_hub_viewer") {
      return false;
    }
    return true;
  };
  const downloadcsv = () => {
    // Check if specialtyList exists and has data
    if (!specialtyList || !specialtyList.specialties || !Array.isArray(specialtyList.specialties) || specialtyList.specialties.length === 0) {
      addToast(
        infoToastConfig("No specialty data available to export.", "warning")
      );
      return;
    }

    const result = [];
    const splitop = [];
    const x = JSON.parse(JSON.stringify(specialtyList));
    
    for (let i = 0; i < x.specialties.length; i++) {
      x.specialties[i].responsibility_code = x.specialties[i]
        .responsibility_code
        ? x.specialties[i].responsibility_code.split(",")
        : [];
      if (x.specialties[i].responsibility_code.length) {
        for (let j = 0; j < x.specialties[i].responsibility_code.length; j++) {
          splitop.push({
            ...x.specialties[i],
            responsibility_code: x.specialties[i].responsibility_code[j],
          });
        }
      } else {
        splitop.push({ ...x.specialties[i], responsibility_code: "" });
      }
    }
    x.specialties = splitop;
    for (let i = 0; i < x.specialties.length; i++) {
      result.push({ ...x, specialties: x.specialties[i] });
    }
    const final = [];
    result.forEach((value, index, arr) => {
      final.push({
        Created_by: (value.created_by?.first_name || "") + " " + (value.created_by?.last_name || ""),
        created_date: value.created_date || "",
        department: value.department_field || "",
        thpc_nm: value.thpc_nm || "",
        dsst_nm: value.dsst_nm || "",
        mdpr_nm: value.mdpr_nm || "",
        indication_nm: value.indication_nm || "",
        brand_nm: value.brand_nm || "",
        quarter: value.list_quarter || "",
        list_status: value.list_status || "",
        list_title: value.list_title || "",
        incentivized: value.specialties?.incentivized || false,
        responsibility_code: value.specialties?.responsibility_code || "",
        specialty_code: value.specialties?.specialty_code || "",
        specialty_description: value.specialties?.specialty_description || "",
        updated_by: (value.updated_by?.first_name || "") + " " + (value.updated_by?.last_name || ""),
        updated_date: value.updated_date || "",
      });
    });
    
    // Check if final array has data before exporting
    if (final.length === 0) {
      addToast(
        infoToastConfig("No data to export.", "warning")
      );
      return;
    }
    
    // Generate filename with list title and timestamp
    const generateFilename = () => {
      const listTitle = specialtyList?.list_title || 'List';
      
      // Sanitize the title for filename use
      const sanitizedTitle = listTitle
        .replace(/[<>:"/\\|?*]/g, '') // Remove invalid filename characters
        .replace(/[\s]+/g, '-') // Replace spaces with hyphens
        .replace(/[^\w\-.]/g, '') // Keep only word characters, hyphens, and dots
        .replace(/--+/g, '-') // Replace multiple consecutive hyphens with single hyphen
        .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
        .substring(0, 80); // Limit length to 80 characters
      
      // Generate timestamp in YYYYMMDD_HHMMSS format
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const timestamp = `${year}${month}${day}_${hours}${minutes}${seconds}`;
      
      return `${sanitizedTitle}_${timestamp}`;
    };
    
    exportExcelSheet(final, generateFilename());
  };
  const convertDateFormat = (dateObj) => {
    if (!dateObj) return "";
    
    // Handle different date formats from the database
    let dt;
    if (dateObj.includes('T') || dateObj.includes('Z')) {
      // ISO format date - parse directly
      dt = new Date(dateObj);
    } else {
      // Database timestamp format like "2025-10-21 11:27:22.105057"
      // Treat as local time, don't add 'Z' suffix
      dt = new Date(dateObj);
    }
    
    return moment(dt).format("dddd, MMMM Do YYYY, h:mm:ss a");
  };
  const getCreateUpdateBy = (details) => {
    if (details && details.first_name && details.last_name) {
      return `${details.first_name} ${details.last_name}`;
    }
    return "";
  };

  // eslint-disable-next-line no-unused-vars
  const getApprovedBy = (details) => {
  if (details && details.first_name && details.last_name) {
    return `${details.first_name} ${details.last_name}`;
  }
  return "";
};
  const checkListStatus = () => {
    const userRole = sessionStorage.getItem("role")?.trim() || "";
    
    if (
      specialtyList &&
      specialtyList.list_status !== "APPROVED" &&
      specialtyList.list_status !== "ARCHIVE" &&
      userRole !== "spclty_hub_viewer" &&
      userRole !== "spclty_hub_bia_team"
    ) {
      const currentRole = userRole;
      const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
      const isSalesforceList = !isMLRList;
      
      // NEW: Check department access first
      if (!hasDepartmentAccess()) {
        return false;
      }
      
      // Salesforce roles (HCP SF Marketer, Incentivized Approver) CANNOT edit MLR lists
      if ((currentRole === "spclty_hub_hcp_sf_marketer" || currentRole === "spclty_hub_incentivized_approver") && isMLRList) {
        return false;
      }
      
      // MLR roles (HCP Marketer, Omnichannel, MLR Reviewer, MLR Approver) CANNOT edit Salesforce lists
      if ((currentRole === "spclty_hub_hcp_marketer" || 
           currentRole === "spclty_hub_omnichannel_advisor" || 
           currentRole === "spclty_hub_mlr_reviewer" || 
           currentRole === "spclty_hub_mlr_approver") && isSalesforceList) {
        return false;
      }
      
      // MLR Approver and MLR Reviewer have limited access even to MLR lists
      if (currentRole === "spclty_hub_mlr_approver" || currentRole === "spclty_hub_mlr_reviewer") {
        return false;
      }
      
      // Incentivized Approver has limited access even to Salesforce lists
      if (currentRole === "spclty_hub_incentivized_approver") {
        return false;
      }
      
      // HCP SF Marketer CAN manage RC codes on Salesforce lists (incentivized checkbox and RC selection)
      // Any HCP SF Marketer who shares brand access can edit DRAFT SF lists (cross-user editing).
      if (currentRole === "spclty_hub_hcp_sf_marketer" && isSalesforceList) {
        if (isCreatorOrAdmin() || hasSharedBrandAccess()) {
          return true;
        }
        return false;
      }

      // NEW: For DRAFT lists, only creator + admin can edit
      if (specialtyList.list_status === "DRAFT") {
        return isCreatorOrAdmin();
      }
      return true;
    }

    return false;
  };
  
  // Check if Submit/Draft buttons should be visible
  const showSubmitDraftButtons = () => {
    if (!specialtyList) return false;
    
    const userRole = sessionStorage.getItem("role")?.trim() || "";
    
    // Check department access first
    if (!hasDepartmentAccess()) {
      return false;
    }
    
    const currentRole = userRole;
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    const isSalesforceList = !isMLRList;
    
    // Super Admin can see buttons on ALL lists (override capability)
    if (currentRole === "spclty_hub_super_admin") {
      if (specialtyList.list_status !== "APPROVED" && specialtyList.list_status !== "ARCHIVE") {
        return true;
      }
      return false;
    }
    
    // Admin CANNOT approve/review MLR or Salesforce lists (only Super Admin can)
    // Admin can only create and route lists
    if (currentRole === "spclty_hub_admin") {
      // Admin can see buttons only for DRAFT
      if (specialtyList.list_status === "DRAFT") {
        return true;
      }
      // Admin CANNOT see buttons for review/approval statuses
      return false;
    }

    // Separation of Duties: a non-admin approver/reviewer cannot approve/review
    // a list they created themselves.
    if (
      (currentRole === "spclty_hub_mlr_approver" ||
        currentRole === "spclty_hub_mlr_reviewer" ||
        currentRole === "spclty_hub_incentivized_approver") &&
      currentRoleUuid
    ) {
      const creatorUuid = typeof specialtyList.created_by === 'object'
        ? specialtyList.created_by?.uuid
        : specialtyList.created_by;
      if (creatorUuid && creatorUuid === currentRoleUuid) {
        return false;
      }
    }

    // Salesforce roles CANNOT see buttons on MLR lists
    if ((currentRole === "spclty_hub_hcp_sf_marketer" || currentRole === "spclty_hub_incentivized_approver") && isMLRList) {
      return false;
    }
    
    // MLR roles CANNOT see buttons on Salesforce lists
    if ((currentRole === "spclty_hub_hcp_marketer" || 
         currentRole === "spclty_hub_omnichannel_advisor" || 
         currentRole === "spclty_hub_mlr_reviewer" || 
         currentRole === "spclty_hub_mlr_approver") && isSalesforceList) {
      return false;
    }
    
    // HCP Marketer and Omnichannel Advisor can only see buttons for DRAFT statuses on MLR lists
    // They CANNOT see buttons during REQUEST FOR REVIEW or REQUEST FOR APPROVAL (only reviewers/approvers can)
    if ((currentRole === "spclty_hub_hcp_marketer" || currentRole === "spclty_hub_omnichannel_advisor") && isMLRList) {
      // Allow buttons for DRAFT lists (if they're the creator)
      if (specialtyList.list_status === "DRAFT") {
        // Handle both object and string formats for created_by
        const creatorUuid = typeof specialtyList.created_by === 'object' 
          ? specialtyList.created_by?.uuid 
          : specialtyList.created_by;
        const isCreator = currentRoleUuid && creatorUuid === currentRoleUuid;
        return isCreator;
      }
      // Deny buttons for all other statuses (REQUEST FOR REVIEW, REQUEST FOR APPROVAL, etc.)
      return false;
    }
    
    // HCP SF Marketer: any SF Marketer with shared brand access can see submit/draft buttons on DRAFT SF lists
    if (currentRole === "spclty_hub_hcp_sf_marketer" && isSalesforceList) {
      if (specialtyList.list_status !== "APPROVED" && specialtyList.list_status !== "ARCHIVE") {
        return isCreatorOrAdmin() || hasSharedBrandAccess();
      }
      return false;
    }
    
    // INC can see buttons when list is in REQUEST FOR APPROVAL status (to approve SF lists)
    if (
      currentRole === "spclty_hub_incentivized_approver" &&
      specialtyList.list_quarter &&
      specialtyList.list_status === "REQUEST FOR APPROVAL"
    ) {
      return true;
    }
    
    if (
      specialtyList.list_status !== "APPROVED" &&
      specialtyList.list_status !== "ARCHIVE" &&
      currentRole !== "spclty_hub_viewer" &&
      currentRole !== "spclty_hub_bia_team" &&
      currentRole !== "spclty_hub_incentivized_approver"
    ) {
      // For DRAFT lists, only creator can see submit/draft buttons (not admin)
      if (specialtyList.list_status === "DRAFT") {
        // Handle both object and string formats for created_by
        const creatorUuid = typeof specialtyList.created_by === 'object' 
          ? specialtyList.created_by?.uuid 
          : specialtyList.created_by;
        const isCreator = currentRoleUuid && creatorUuid === currentRoleUuid;
        if (isCreator) {
          return true;
        }
        return false;
      }
      return true;
    }
    return false;
  };
  

  const checkListStatusSuperAdmin = () => {
    const userRole = sessionStorage.getItem("role")?.trim() || "";
    if (userRole === "spclty_hub_super_admin") {
      return true;
    }

    return false;
  };
  const badgeColourClass = () => {
    if (specialtyList.list_status === "DRAFT") {
      return "draft-badge";
    } else {
      return "green-btn";
    }
  };

  const editBrandIndicationTitle = async () => {
    const acquired = await lockList();
    if (!acquired) return;
    seteditBrandIndication(true);
  };
  const closeBrandIndicationEdit = () => {
    seteditBrandIndication(false);
    unlockList();
  };
  const saveMetaData = async (metaObj) => {
    const updatedObjID = specialtyList.uuid;
    // Ensure audit/update metadata is set and strip any lock fields so the
    // save does not leave the list locked for the current user when the
    // subsequent refresh occurs.
    metaObj.updated_by = currentRoleUuid || uuid;
    delete metaObj.locked_by;
    delete metaObj.locked_at;
 
    await dispatch(
      UPDATE_SPECIALITYLIST({ updatedList: metaObj, UUID: updatedObjID })
    );
    // Best-effort release of the lock client-side (heartbeat/unload also handle this)
    await unlockList();
  };
  const checkSpecialtyListLen = (slist) => {
    if (slist && slist.specialties && slist.specialties.length > 0) {
      return true;
    }
    return false;
  };

  const filterSpecialityCodeList = () => {
    const tempVisibleSpecialties = JSON.parse(
      JSON.stringify(visibleSpecialties)
    );
    if (searchText) {
      tempVisibleSpecialties.specialties = visibleSpecialties.specialties.map(
        (s) => {
          s.show =
            s.responsibility_code?.toLowerCase().includes(searchText.toLowerCase()) ||
            s.specialty_code?.toLowerCase().includes(searchText.toLowerCase()) ||
            s.specialty_description?.toLowerCase().includes(searchText.toLowerCase());
          return s;
        }
      );
    } else {
      tempVisibleSpecialties.specialties = visibleSpecialties.specialties.map(
        (s) => ({
          ...s,
          show: true,
        })
      );
    }
    setVisibleSpecialties(tempVisibleSpecialties);

    setTotalPages(
      Math.ceil(
        tempVisibleSpecialties.specialties.filter((specialty) => specialty.show)
          .length / pageSize
      )
    );
    updateCurrentPage(1);
  };

  const showAddRespButton = () => {
    // Check department access first
    if (!hasDepartmentAccess()) {
      return false;
    }
    
    // MLR lists (empty list_quarter) should not have RC functionality at all
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    if (isMLRList) {
      return false;
    }
    
    // MLR roles CANNOT add/remove RC on Salesforce lists
    if (
      userRole === "spclty_hub_hcp_marketer" ||
      userRole === "spclty_hub_omnichannel_advisor" ||
      userRole === "spclty_hub_mlr_approver" ||
      userRole === "spclty_hub_mlr_reviewer"
    ) {
      return false;
    }
    
    // Incentivized approver should not be able to add/remove responsibility codes
    if (userRole === "spclty_hub_incentivized_approver") {
      return false;
    }
    
    // eslint-disable-next-line no-constant-condition
    if (
      (userRole === "spclty_hub_admin" &&
        specialtyList.list_status !== "APPROVED" &&
        specialtyList.list_status !== "ARCHIVE") ||
      (userRole === "spclty_hub_hcp_sf_marketer" &&
        specialtyList.list_status !== "APPROVED" &&
        specialtyList.list_status !== "ARCHIVE") ||
      (userRole === "spclty_hub_super_admin" &&
        specialtyList.list_status !== "APPROVED" &&
        specialtyList.list_status !== "ARCHIVE")
    ) {
      // For HCP SF Marketer: any SF Marketer with shared brand access can add/remove RC codes
      if (userRole === "spclty_hub_hcp_sf_marketer") {
        return isCreatorOrAdmin() || hasSharedBrandAccess();
      }
      // For DRAFT lists: only creator + admin can add/remove RC
      if (specialtyList.list_status === "DRAFT") {
        return isCreatorOrAdmin();
      }
      return true;
    }
    return false;
  };
  const showaddMultiResponsibilitiesModal = async (respmode) => {
    setrespmode(respmode);
    if (selectedValues.length === 0) {
      addToast(
        infoToastConfig(
          "Please Select Specialties in which  Responsibility Code needs to be added.",
          "error"
        )
      );
      return;
    }
    const acquired = await lockList();
    if (!acquired) return;
    setIsRespModalOpen(true);
  };
  const updateMultiSelectedResponsibility = (selectedResponsibility) => {
    if (respmode === "add") {
        for (let i = 0; i < selectedValues.length; i++) {
          const checkedSpecialties =
            visibleSpecialties.specialties[selectedValues[i]];
          checkedSpecialties.responsibility_code = Array.from(
            new Set(
              (checkedSpecialties.responsibility_code !== ""
                ? checkedSpecialties.responsibility_code +
                  "," +
                  selectedResponsibility
                : checkedSpecialties.responsibility_code + selectedResponsibility
              ).split(",")
            )
          ).toString();
          checkedSpecialties.incentivized = true;
        }
      selectedResponsibility = "";
      // dispatch(FETCH_RESPONSIBILITY_LIST());
    }
    if (respmode === "remove") {
      const selectedResponsibilityArr = selectedResponsibility.split(",");
      for (let i = 0; i < selectedValues.length; i++) {
        const checkedSpecialties =
          visibleSpecialties.specialties[selectedValues[i]];
        checkedSpecialties.responsibility_code =
          checkedSpecialties.responsibility_code
            .split(",")
            .filter((n) => !selectedResponsibilityArr.includes(n))
            .toString();
        checkedSpecialties.responsibility_code === ""
          ? (checkedSpecialties.incentivized = false)
          : (checkedSpecialties.incentivized = true);
      }
      selectedResponsibility = "";
    }
  };
  const showDeleteButton = () => {
    // Check department access first
    if (!hasDepartmentAccess()) {
      return false;
    }
    
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    const isSalesforceList = !isMLRList;
    
    // Salesforce roles CANNOT delete specialty codes from MLR lists
    if ((userRole === "spclty_hub_hcp_sf_marketer" || userRole === "spclty_hub_incentivized_approver") && isMLRList) {
      return false;
    }
    
    // MLR roles CANNOT delete specialty codes from Salesforce lists
    if ((userRole === "spclty_hub_hcp_marketer" || 
         userRole === "spclty_hub_omnichannel_advisor" || 
         userRole === "spclty_hub_mlr_reviewer" || 
         userRole === "spclty_hub_mlr_approver") && isSalesforceList) {
      return false;
    }
    
    // Only roles that can CREATE lists should be able to DELETE specialty codes
    // Allowed: SA, AD, HCP, OMN
    // Blocked: VIEW, MLR-R, MLR-A, INC, BIA, HCPSF (SF manages RC codes, not specialty codes)
    const canDeleteRoles = [
      "spclty_hub_super_admin",
      "spclty_hub_admin", 
      "spclty_hub_hcp_marketer",
      "spclty_hub_omnichannel_advisor"
    ];
    
    if (
      canDeleteRoles.includes(userRole) &&
      specialtyList.list_status !== "APPROVED" &&
      specialtyList.list_status !== "ARCHIVE"
    ) {
      // NEW: For DRAFT lists, only creator + admin can delete specialties
      if (specialtyList.list_status === "DRAFT") {
        return isCreatorOrAdmin();
      }
      return true;
    }
    return false;
  };
  const deleteMultiple = async () => {
    if (selectedValues.length === 0) {
      addToast(
        infoToastConfig(
          "Please Select Specialties Which Needs to be Deleted.",
          "error"
        )
      );
      return;
    }
    const acquired = await lockList();
    if (!acquired) return;
    setdeleteMultipleSpecialties(true);
    setIsDelModalOpen(true);
  };
  const getTableColumn = () => {
    // MLR lists (empty list_quarter) should not show RC columns
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    
    if (
      userRole === "spclty_hub_hcp_marketer" ||
      userRole === "spclty_hub_omnichannel_advisor" ||
      userRole === "spclty_hub_mlr_approver" ||
      userRole === "spclty_hub_mlr_reviewer" ||
      isMLRList
    ) {
      // return col.splice(col.length - 2, 2);
      return theadSf;
    }
    return thead;
  };

  const selectAllSpecialties = (selectAll) => {
    // setting the operation(select/deselect all) to perform
    selectAll = selectAll === "Select All";
    const visibleSpecialtiesCopy = JSON.parse(
      JSON.stringify(visibleSpecialties)
    );

    // copy of selected specialties
    let chkbx = [...selectedValues];

    for (let i in visibleSpecialtiesCopy.specialties) {
      // converting i to number
      i = Number(i);
      // only selecting/deselectiong the visible specialties
      if (visibleSpecialtiesCopy.specialties[i].show) {
        visibleSpecialtiesCopy.specialties[i].selectedSpecialty = selectAll;

        // adding/removing current specialty in selected specialties
        if (selectAll) {
          if (!chkbx.includes(i)) {
            chkbx.push(i);
          }
        } else {
          const index = chkbx.indexOf(i);
          if (index > -1) {
            chkbx.splice(index, 1);
          }
        }
      }
    }
    setselectedValues(chkbx);
    setVisibleSpecialties(visibleSpecialtiesCopy);
  };

  const selectOrUnselect = () => {
    // setting the select/deselect all text based on currently visible selected specialties
    const allSpecialtiesSelected = visibleSpecialties?.specialties
      ?.filter((sp) => sp.show)
      ?.every((sp) => sp.selectedSpecialty);
    if (allSpecialtiesSelected) {
      return "Deselect All";
    }
    return "Select All";
  };

  const checkOmniOrHCPOrMLRRole = () => {
    // MLR lists (empty list_quarter) should not show RC columns
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    
    // eslint-disable-next-line no-constant-condition
    if (
      userRole === "spclty_hub_hcp_marketer" ||
      userRole === "spclty_hub_omnichannel_advisor" ||
      userRole === "spclty_hub_mlr_approver" ||
      userRole === "spclty_hub_mlr_reviewer" ||
      isMLRList
    ) {
      return true;
    }
    return false;
  };

  /**
   * Gets the index of current row from visibleSpecialties.specialties
   *
   * @param {Object} item row data object
   * @returns index of data in visibleSpecialties.specialties
   */
  const getRowIndex = (item) => {
    const data = visibleSpecialties.specialties;
    return data.findIndex(
      (element) => element.specialty_code === item.specialty_code
    );
  };

  const respCodeContent = (item) => {
    const index = getRowIndex(item);
    return visibleSpecialties.specialties[index].responsibility_code
      ? visibleSpecialties.specialties[index].responsibility_code.replace(
          /,/g,
          ", "
        )
      : "";
  };
  const showSearchResponsibilityModal = async (item) => {
    // MLR lists (empty list_quarter) should not allow RC selection
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    if (isMLRList) {
      return;
    }
    
    // MLR approver and reviewer should not be able to select responsibility codes
    if (
      userRole === "spclty_hub_mlr_approver" ||
      userRole === "spclty_hub_mlr_reviewer"
    ) {
      return;
    }
    
    if (item.incentivized !== true) return;
    const index = getRowIndex(item);
    setupdateResCodeIndex(index);
    dispatch(SET_RESP_INDEX(index));
    const acquired = await lockList();
    if (!acquired) return;
    setIsModalOpen(true);
  };
  const checkRoleSFMarketer = () => {
    // Returns true if user is HCP SF Marketer ONLY
    // INC can only approve, NOT submit for approval
    // Returns false for MLR Approver, MLR Reviewer, and Incentivized Approver
    if (
      sessionStorage.getItem("role") === "spclty_hub_hcp_sf_marketer"
    ) {
      return true;
    }
    return false;
  };
  const deleteSpecialityList = async (item) => {
    const acquired = await lockList();
    if (!acquired) return;
    const index = getRowIndex(item);
    setdeleteMultipleSpecialties(false);
    setdelSpeclIndex(index);
    setIsDelModalOpen(true);
  };
  const DraftSpecialityDetails = async () => {
    // Acquire lock before writing — blocks if another user holds it
    const acquired = await lockList();
    if (!acquired) return;

    const updatedObjID = visibleSpecialties.uuid;
    // Deep copy so we never mutate the React state directly (mutating in-place deletes
    // the 'show' flag used by the table filter, which causes "No data available")
    const updatedList = JSON.parse(JSON.stringify(visibleSpecialties));
    updatedList.list_status = "DRAFT";
    delete updatedList.uuid;
    delete updatedList.updated_date;
    delete updatedList.created_by;
    for (let itm in updatedList.specialties) {
      delete updatedList.specialties[itm].show;
      if (!updatedList.specialties[itm].responsibility_code ||
          updatedList.specialties[itm].responsibility_code.trim() === "") {
        updatedList.specialties[itm].incentivized = false;
      }
    }
    updatedList.updated_by = currentRoleUuid || uuid;
    delete updatedList.locked_by;
    delete updatedList.locked_at;
    const result = await dispatch(
      UPDATE_SPECIALITYLIST({
        updatedList: updatedList,
        UUID: updatedObjID,
      })
    );
    await unlockList();
    if (result.meta?.requestStatus === "fulfilled") {
      addToast(infoToastConfig("Your changes have been saved successfully.", "success"));
    } else {
      addToast(infoToastConfig("Unable to save. The list is locked by another user.", "error"));
    }
  };
  const confirmSubmission = () => {
    // Check department access first
    if (!hasDepartmentAccess()) {
      addToast(
        infoToastConfig("You do not have access to this list's department.", "error")
      );
      return;
    }
    
    // Role-based workflow validation
    const currentStatus = visibleSpecialties.list_status;
    const isMLRList = !visibleSpecialties.list_quarter || visibleSpecialties.list_quarter.trim() === '';
    const isSalesforceList = !isMLRList;
    
    // Check if specialty codes exist before routing for review
    if (!visibleSpecialties.specialties || visibleSpecialties.specialties.length === 0) {
      addToast(
        infoToastConfig("Please add specialty codes before routing for review.", "error")
      );
      return;
    }
    
    // ===== WORKFLOW SEPARATION: Prevent cross-workflow access =====
    
    // Salesforce roles CANNOT submit/approve MLR lists
    if ((userRole === "spclty_hub_hcp_sf_marketer" || userRole === "spclty_hub_incentivized_approver") && isMLRList) {
      addToast(
        infoToastConfig("HCP SF Marketer and Incentivized Approver can only work with Salesforce lists (with quarter), not MLR lists.", "error")
      );
      return;
    }
    
    // MLR roles CANNOT submit/approve Salesforce lists
    if ((userRole === "spclty_hub_hcp_marketer" || 
         userRole === "spclty_hub_omnichannel_advisor" || 
         userRole === "spclty_hub_mlr_reviewer" || 
         userRole === "spclty_hub_mlr_approver") && isSalesforceList) {
      addToast(
        infoToastConfig("HCP Marketer, Omnichannel Advisor, MLR Reviewer, and MLR Approver can only work with MLR lists (without quarter), not Salesforce lists.", "error")
      );
      return;
    }
    
    // ===== END WORKFLOW SEPARATION =====
    
    // Super Admin has override capability - can review/approve any list at any valid status
    const isSuperAdmin = userRole === "spclty_hub_super_admin";
    
    // Admin CANNOT approve or review lists - only Super Admin can override
    if (userRole === "spclty_hub_admin") {
      // Admin can only route lists from DRAFT
      if (currentStatus !== "DRAFT") {
        addToast(
          infoToastConfig("Admin cannot review or approve lists. Only Super Admin has override approval capability.", "error")
        );
        return;
      }
    }
    
    // MLR Approver can only approve lists in REQUEST FOR APPROVAL status
    // Super Admin can also approve at this status (override)
    if ((userRole === "spclty_hub_mlr_approver" || isSuperAdmin) && currentStatus === "REQUEST FOR APPROVAL") {
      // Allow approval - validation passed
    } else if (userRole === "spclty_hub_mlr_approver" && currentStatus !== "REQUEST FOR APPROVAL") {
      addToast(
        infoToastConfig("MLR Approver can only approve lists that are in 'Request for Approval' status.", "error")
      );
      return;
    }
    
    // MLR Reviewer can only review lists in REQUEST FOR REVIEW status
    // Super Admin can also review at this status (override)
    if ((userRole === "spclty_hub_mlr_reviewer" || (isSuperAdmin && currentStatus === "REQUEST FOR REVIEW")) && currentStatus === "REQUEST FOR REVIEW") {
      // Allow review - validation passed
    } else if (userRole === "spclty_hub_mlr_reviewer" && currentStatus !== "REQUEST FOR REVIEW") {
      addToast(
        infoToastConfig("MLR Reviewer can only review lists that are in 'Request for Review' status.", "error")
      );
      return;
    }
    
    // Validate DRAFT status routing - only creator, Admin, and Super Admin can route for review
    if (currentStatus === "DRAFT") {
      if (!isSuperAdmin && !isCreatorOrAdmin()) {
        addToast(
          infoToastConfig("Only the list creator, Admin, or Super Admin can submit this list for review.", "error")
        );
        return;
      }
    }
    
    // For MLR lists in DRAFT status, prevent approver/reviewer from submitting
    // Super Admin is exempt from this restriction (override)
    if (isMLRList && currentStatus === "DRAFT" && !isSuperAdmin) {
      if (userRole === "spclty_hub_mlr_approver" || userRole === "spclty_hub_mlr_reviewer") {
        addToast(
          infoToastConfig("Only list creators can submit MLR lists from Draft status.", "error")
        );
        return;
      }
    }
    
    if (
      visibleSpecialties.specialties.find(
        (val) => val.incentivized === true && val.responsibility_code === ""
      ) !== undefined
    ) {
      addToast(infoToastConfig("Please Select Responsibility Code.", "error"));
      return;
    }
    if (visibleSpecialties.hasOwnProperty("created")) {
      setAddedSpecialtyCodes(
        visibleSpecialties.created.map((itm) => {
          return {
            ...itm,
            status: "Created",
          };
        })
      );
    } else {
      setAddedSpecialtyCodes([]);
    }
    if (visibleSpecialties.hasOwnProperty("updated")) {
      setUncommonRespCodes(
        visibleSpecialties.updated.map((itm) => {
          return {
            ...itm,
            status: "Updated",
          };
        })
      );
    } else {
      setUncommonRespCodes([]);
    }
    if (visibleSpecialties.hasOwnProperty("deleted")) {
      setDelSpecialtyCodes(
        visibleSpecialties.deleted.map((itm) => {
          return {
            ...itm,
            status: "Deleted",
          };
        })
      );
    } else {
      setDelSpecialtyCodes([]);
    }
    
    // ===== SUPER ADMIN: Direct approval from ANY status =====
    if (userRole === "spclty_hub_super_admin") {
      setMsg("Are you sure you want to approve this list?");
      setListAppModalOpen(true);
      return; // Skip all other role-based message logic
    }
    // ===== END SUPER ADMIN =====
    
    if (
      userRole === "spclty_hub_mlr_approver" &&
      !visibleSpecialties.list_quarter &&
      visibleSpecialties.list_status === "REQUEST FOR APPROVAL"
    ) {
      setMsg("Are you sure want to approve ?");
    } else if (userRole === "spclty_hub_mlr_reviewer") {
      // MLR Reviewers only submit reviews
      // After all reviewers complete, list auto-transitions to REQUEST FOR APPROVAL
      setMsg("Are you sure you want to Submit Review ?");
    } else if (
      userRole === "spclty_hub_incentivized_approver" &&
      visibleSpecialties.list_quarter &&
      visibleSpecialties.list_status === "REQUEST FOR APPROVAL"
    ) {
      setMsg("Are you sure want to approve ?");
    } else if (
      userRole === "spclty_hub_hcp_sf_marketer" &&
      visibleSpecialties.list_quarter
    ) {
      setMsg("Are you sure want to request for approval ?");
    } else if (
      userRole === "spclty_hub_hcp_sf_marketer" &&
      !visibleSpecialties.list_quarter
    ) {
      setMsg("Are you sure want to request for Review ?");
    } else if (
      userRole === "spclty_hub_mlr_approver" &&
      !visibleSpecialties.list_quarter &&
      visibleSpecialties.list_status !== "REQUEST FOR APPROVAL"
    ) {
      setMsg("Are you sure want to request for Review ?");
    } else if (
      userRole !== "spclty_hub_hcp_sf_marketer" &&
      userRole !== "spclty_hub_incentivized_approver" &&
      visibleSpecialties.list_quarter
    ) {
      setMsg("Are you sure want to request for approval ?");
    } 
    else if (
      !visibleSpecialties.list_quarter &&
      visibleSpecialties.list_status === "DRAFT"
    ) {
      // MLR lists must go through review first
      setMsg("Are you sure want to request for Review ?");
    } else {
      setMsg("Are you sure want to request for Review ?");
    }
    setListAppModalOpen(true);
  };
  const updateSpecialityDetails = async (approverUserList, mlrApproverUserList) => {
    let toastMsg;
    const currentStatus = visibleSpecialties.list_status;
    const isMLRList = !visibleSpecialties.list_quarter || visibleSpecialties.list_quarter.trim() === '';
    const isSuperAdmin = userRole === "spclty_hub_super_admin";
    
    // ===== SUPER ADMIN OVERRIDE LOGIC =====
    // Super Admin can directly approve ANY list from ANY status (ultimate override)
    if (isSuperAdmin) {
      // Directly approve the list regardless of current status
      visibleSpecialties.list_status = "APPROVED";
      toastMsg = "Specialty list has been directly approved by Super Admin.";
      
      // Add Super Admin to approverlist and approversubmitted for audit trail
      if (!visibleSpecialties.approverlist) {
        visibleSpecialties.approverlist = [];
      }
      if (!visibleSpecialties.approverlist.includes(currentRoleUuid)) {
        visibleSpecialties.approverlist.push(currentRoleUuid);
      }
      
      if (!visibleSpecialties.approversubmitted) {
        visibleSpecialties.approversubmitted = [];
      }
      if (!visibleSpecialties.approversubmitted.includes(currentRoleUuid)) {
        visibleSpecialties.approversubmitted.push(currentRoleUuid);
      }
      
      // ONLY for MLR lists: Add to reviewerlist if coming from a review state
      // Salesforce lists don't have reviewers, only approvers
      if (isMLRList && currentStatus === "REQUEST FOR REVIEW") {
        if (!visibleSpecialties.reviewerlist) {
          visibleSpecialties.reviewerlist = [];
        }
        if (!visibleSpecialties.reviewerlist.includes(currentRoleUuid)) {
          visibleSpecialties.reviewerlist.push(currentRoleUuid);
        }
        
        if (!visibleSpecialties.reviewsubmitted) {
          visibleSpecialties.reviewsubmitted = [];
        }
        if (!visibleSpecialties.reviewsubmitted.includes(currentRoleUuid)) {
          visibleSpecialties.reviewsubmitted.push(currentRoleUuid);
        }
      }
    }
    // ===== END SUPER ADMIN OVERRIDE =====
    
    // MLR Approver - can only approve from REQUEST FOR APPROVAL status
    else if (
      userRole === "spclty_hub_mlr_approver" &&
      !visibleSpecialties.list_quarter &&
      visibleSpecialties.list_status === "REQUEST FOR APPROVAL"
    ) {
      const filteredArray = useruuids.filter((value) =>
        visibleSpecialties.approverlist.includes(value)
      );
      if (!visibleSpecialties.approversubmitted) {
        visibleSpecialties.approversubmitted = [];
      }
      if (!visibleSpecialties.approversubmitted?.includes(filteredArray[0])) {
        visibleSpecialties.approversubmitted?.push(filteredArray[0]);
      }
      if (
        visibleSpecialties.approverlist?.filter(
          (item) => !visibleSpecialties.approversubmitted.includes(item)
        ).length === 0
      ) {
        visibleSpecialties.list_status = "APPROVED";
        toastMsg = "Specialty list has been approved.";
      } else {
        toastMsg = "Specialty list has been Approved by you.";
      }
    } 
    // MLR Reviewer - can only review from REQUEST FOR REVIEW status
    else if (userRole === "spclty_hub_mlr_reviewer") {
      const filteredArray = useruuids.filter((value) =>
        visibleSpecialties.reviewerlist.includes(value)
      );
      if (!visibleSpecialties.reviewsubmitted?.includes(filteredArray[0])) {
        visibleSpecialties.reviewsubmitted?.push(filteredArray[0]);
      }
      // Check if all reviewers have submitted
      if (
        visibleSpecialties.reviewerlist?.filter(
          (item) => !visibleSpecialties.reviewsubmitted.includes(item)
        ).length === 0
      ) {
        // After all reviewers complete, auto-transition to REQUEST FOR APPROVAL
        // Approvers were already selected at submission time
        visibleSpecialties.list_status = "REQUEST FOR APPROVAL";
        toastMsg = "All reviews completed. List has been automatically routed for approval.";
      } else {
        toastMsg = "Specialty list has been Reviewed.";
      }
    } else if (
      userRole === "spclty_hub_incentivized_approver" &&
      visibleSpecialties.list_quarter &&
      visibleSpecialties.list_status === "REQUEST FOR APPROVAL"
    ) {
      const filteredArray = useruuids.filter((value) =>
        visibleSpecialties.approverlist.includes(value)
      );
      if (!visibleSpecialties.approversubmitted) {
        visibleSpecialties.approversubmitted = [];
      }
      if (!visibleSpecialties.approversubmitted?.includes(filteredArray[0])) {
        visibleSpecialties.approversubmitted?.push(filteredArray[0]);
      }
      if (
        visibleSpecialties.approverlist?.filter(
          (item) => !visibleSpecialties.approversubmitted.includes(item)
        ).length === 0
      ) {
        visibleSpecialties.list_status = "APPROVED";
        toastMsg = "Specialty list has been approved.";
      } else {
        toastMsg = "Specialty list has been Approved by you.";
      }
    } else if (
      (userRole === "spclty_hub_hcp_sf_marketer") &&
      !visibleSpecialties.list_quarter
    ) {
      // MLR lists always go to review first
      visibleSpecialties.list_status = "REQUEST FOR REVIEW";
      toastMsg = "Specialty list has been sent for review.";
    } else if (
      (userRole === "spclty_hub_hcp_sf_marketer") &&
      visibleSpecialties.list_quarter
    ) {
      // Salesforce lists can go directly to approval
      visibleSpecialties.list_status = "REQUEST FOR APPROVAL";
      toastMsg = "Specialty list has been sent for approval.";
    } 
    else if (
      userRole === "spclty_hub_mlr_approver" &&
      !visibleSpecialties.list_quarter &&
      visibleSpecialties.list_status !== "REQUEST FOR APPROVAL"
    ) {
      // MLR approver cannot skip review - should not reach here for DRAFT lists
      visibleSpecialties.list_status = "REQUEST FOR REVIEW";
      toastMsg = "Specialty list has been sent for review.";
    } else if (
      userRole !== "spclty_hub_hcp_sf_marketer" &&
      userRole !== "spclty_hub_incentivized_approver" &&
      visibleSpecialties.list_quarter
    ) {
      // Salesforce lists can go directly to approval
      visibleSpecialties.list_status = "REQUEST FOR APPROVAL";
      toastMsg = "Specialty list has been sent for the approval.";
    } else if (!visibleSpecialties.list_quarter) {
      // Default for MLR lists - always go to review first
      visibleSpecialties.list_status = "REQUEST FOR REVIEW";
      toastMsg = "Specialty list has been sent for review.";
    } else {
      // Default fallback
      visibleSpecialties.list_status = "REQUEST FOR REVIEW";
      toastMsg = "Specialty list has been sent for review.";
    }
    const updatedObjID = visibleSpecialties.uuid;
    // Deep copy so we never mutate the React state (deleting 'show' causes "No data available")
    const updatedList = JSON.parse(JSON.stringify(visibleSpecialties));
    for (let itm in updatedList.specialties) {
      delete updatedList.specialties[itm].show;
      // If no RC codes attached, set incentivized to false
      if (!updatedList.specialties[itm].responsibility_code ||
          updatedList.specialties[itm].responsibility_code.trim() === "") {
        updatedList.specialties[itm].incentivized = false;
      }
    }
    delete updatedList.uuid;
    delete updatedList.updated_date;
    delete updatedList.created_by;
    delete updatedList.locked_by;
    delete updatedList.locked_at;
    updatedList.updated_by = currentRoleUuid || uuid;
    if (
      visibleSpecialties.list_status === "REQUEST FOR REVIEW" &&
      msg !== "Are you sure you want to Submit Review ?"
    ) {
      // When routing for review, check if any selected reviewers already exist
      // If they do, mark them as already reviewed (green) instead of adding duplicates
      const existingReviewers = updatedList.reviewerlist || [];
      const existingReviewSubmitted = updatedList.reviewsubmitted || [];

      // Remove duplicates from approverUserList using Set
      const uniqueReviewerList = [...new Set(approverUserList)];

      // Set the new reviewer list (deduplicated)
      updatedList.reviewerlist = uniqueReviewerList;

      // For any reviewers who were already in the list and had submitted, keep them as submitted
      updatedList.reviewsubmitted = uniqueReviewerList.filter(reviewerId =>
        existingReviewers.includes(reviewerId) && existingReviewSubmitted.includes(reviewerId)
      );

      // For MLR lists: also store approverlist at submission time (selected alongside reviewers)
      if (isMLRList && mlrApproverUserList && mlrApproverUserList.length > 0) {
        const uniqueApproverList = [...new Set(mlrApproverUserList)];
        updatedList.approverlist = uniqueApproverList;
        updatedList.approversubmitted = [];
      } else {
        // Clear approver list when routing back to review (non-MLR or no approvers selected)
        updatedList.approverlist = [];
        updatedList.approversubmitted = [];
      }
    }
    if (updatedList.list_status === "REQUEST FOR APPROVAL" && approverUserList && approverUserList.length > 0) {
      // When routing for approval, check if any selected approvers already exist
      // If they do, mark them as already approved (green) instead of adding duplicates
      const existingApprovers = updatedList.approverlist || [];
      const existingApproverSubmitted = updatedList.approversubmitted || [];

      // Remove duplicates from approverUserList using Set
      const uniqueApproverList = [...new Set(approverUserList)];

      // Set approverlist when transitioning to or already in REQUEST FOR APPROVAL status
      updatedList.approverlist = uniqueApproverList;

      // For any approvers who were already in the list and had submitted, keep them as submitted
      updatedList.approversubmitted = uniqueApproverList.filter(approverId =>
        existingApprovers.includes(approverId) && existingApproverSubmitted.includes(approverId)
      );

      // If approversubmitted doesn't exist yet, initialize as empty array
      if (!updatedList.approversubmitted) {
        updatedList.approversubmitted = [];
      }
    }
    const result = await dispatch(
      UPDATE_SPECIALITYLIST({
        updatedList: updatedList,
        UUID: updatedObjID,
      })
    );
    if (result.meta?.requestStatus === "fulfilled") {
      addToast(infoToastConfig(toastMsg, "success"));
    } else if (result.payload?.data?.sod_violation) {
      addToast(infoToastConfig(result.payload.message || "This action is not allowed due to separation-of-duties rules.", "error"));
    } else {
      addToast(infoToastConfig("Unable to save. The list is locked by another user.", "error"));
    }
  };
  const handleSaveParticipants = async (payload) => {
    const result = await dispatch(
      UPDATE_LIST_PARTICIPANTS({
        uuid: specialtyList.uuid,
        updated_by: uuid,
        ...payload,
      })
    );
    if (result.meta?.requestStatus === "fulfilled") {
      addToast(infoToastConfig("Reviewers/Approvers updated successfully.", "success"));
    } else if (result.payload?.data?.sod_violation) {
      addToast(infoToastConfig(result.payload.message || "This action is not allowed due to separation-of-duties rules.", "error"));
    } else {
      addToast(infoToastConfig("Unable to update reviewers/approvers.", "error"));
    }
  };
  const checkEditTitle = () => {
    if (editBrandIndication) {
      return "";
    }
    if (
      userRole === "spclty_hub_mlr_approver" &&
      visibleSpecialties.list_status === "REQUEST FOR APPROVAL" &&
      !visibleSpecialties.list_quarter
    ) {
      return "green-btn";
    }
    if (
      userRole === "spclty_hub_incentivized_approver" &&
      visibleSpecialties.list_quarter &&
      visibleSpecialties.list_status === "REQUEST FOR APPROVAL"
    ) {
      return "green-btn";
    }
    return "blue-btn";
  };
  const checkIncentivisedList = (slist, loginRole) => {
    if (
      slist &&
      slist.list_quarter &&
      loginRole === "spclty_hub_incentivized_approver"
    ) {
      return true;
    }
    if (
      slist &&
      !slist.list_quarter &&
      loginRole === "spclty_hub_mlr_approver"
    ) {
      return true;
    }

    return false;
  };
  const selcheckBoxClicked = (event, item) => {
    const tempData = JSON.parse(JSON.stringify(visibleSpecialties));
    const index = getRowIndex(item);

    let chkbx = JSON.parse(JSON.stringify(selectedValues));
    if (event.target.checked === true) {
      tempData.specialties[index].selectedSpecialty = true;
      chkbx.push(index);
    } else {
      tempData.specialties[index].selectedSpecialty = false;
      chkbx = selectedValues.filter(function (idx) {
        return idx !== index;
      });
    }

    setselectedValues(chkbx);
    setVisibleSpecialties(tempData);
  };
  const incvcheckBoxClicked = async (event, item) => {
    // MLR lists (empty list_quarter) should not allow incentivized/RC functionality
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    if (isMLRList) {
      return;
    }
    
    // MLR approver and reviewer should not be able to modify incentivized status
    if (
      userRole === "spclty_hub_mlr_approver" ||
      userRole === "spclty_hub_mlr_reviewer"
    ) {
      return;
    }

    // Acquire lock before modifying incentivized status
    const acquired = await lockList();
    if (!acquired) return;
    
    const tempData = JSON.parse(JSON.stringify(visibleSpecialties));
    const listIndex = getRowIndex(item);
    const toggleSpeciality = !!event.target.checked;
    if (!toggleSpeciality) {
      tempData.specialties[listIndex].responsibility_code = "";
    }
    tempData.specialties[listIndex].incentivized = toggleSpeciality;
    setVisibleSpecialties(tempData);
    if (!tempData.specialties[listIndex].selectedSpecialty) {
      showSearchResponsibilityModal(tempData.specialties[listIndex]);
    }
  };
  const confirmDelete = (isConfirmDel) => {
    const tempData = JSON.parse(JSON.stringify(visibleSpecialties));
    if (
      isConfirmDel &&
      isConfirmDel === "Yes" &&
      deleteMultipleSpecialties === false
    ) {
      tempData.specialties = tempData.specialties.filter(
        (el, index) => index !== delSpeclIndex
      );
      setVisibleSpecialties(tempData);
      dispatch(SET_SPECIALITY_LIST(tempData));
      const tempselcvalues = [];
      for (let i in tempData.specialties) {
        if (tempData.specialties[i].selectedSpecialty === true) {
          tempselcvalues.push(i * 1);
        }
      }

      setselectedValues(tempselcvalues);
      setIsDelModalOpen(false);
      return;
    }
    if (
      isConfirmDel &&
      isConfirmDel === "Yes" &&
      selectedValues.length > 0 &&
      deleteMultipleSpecialties === true
    ) {
      let selectedSpecialtyCodes = [];
      for (let i in selectedValues) {
        selectedSpecialtyCodes.push(
          visibleSpecialties.specialties[selectedValues[i]].specialty_code
        );
      }

      for (let i = 0; i < selectedSpecialtyCodes.length; i++) {
        tempData.specialties = tempData.specialties.filter(
          (obj) => obj.specialty_code !== selectedSpecialtyCodes[i]
        );
      }
      setVisibleSpecialties(tempData);
      dispatch(SET_SPECIALITY_LIST(tempData));
      setselectedValues([]);
      setIsDelModalOpen(false);
      return;
    }
    // User clicked "No" or closed the modal — release the lock
    unlockList();
  };
  const updateSelectedResponsibility = (selectedResponsibility) => {
    // Check if updateResCodeIndex is valid
    if (updateResCodeIndex === undefined || updateResCodeIndex === null) {
      return;
    }
    
    const tempData = JSON.parse(JSON.stringify(visibleSpecialties));
    
    // Safety check for specialties array and index
    if (!tempData || !tempData.specialties || !Array.isArray(tempData.specialties) || 
        updateResCodeIndex < 0 || updateResCodeIndex >= tempData.specialties.length) {
      return;
    }
    
    // Safety check for the specific specialty object
    if (!tempData.specialties[updateResCodeIndex]) {
      return;
    }
    
    // Update responsibility code
    tempData.specialties[updateResCodeIndex].responsibility_code =
      selectedResponsibility;
    
    // If no responsibility code is selected, set incentivized to false
    if (!selectedResponsibility || selectedResponsibility.trim() === "") {
      tempData.specialties[updateResCodeIndex].incentivized = false;
    }
    
    // Update the state to reflect the changes
    setVisibleSpecialties(tempData);
  };

  const allowToEditTitleAndMetaData = () => {
    const userRole = sessionStorage.getItem("role")?.trim() || "";
    
    // Check department access first - this handles role-based department restrictions
    if (!hasDepartmentAccess()) {
      return false;
    }
    
    const isMLRList = !specialtyList.list_quarter || specialtyList.list_quarter.trim() === '';
    const isSalesforceList = !isMLRList;
    
    // Salesforce roles CANNOT edit title/metadata on MLR lists
    if ((userRole === "spclty_hub_hcp_sf_marketer" || 
         userRole === "spclty_hub_incentivized_approver") && isMLRList) {
      return false;
    }
    
    // MLR roles CANNOT edit title/metadata on Salesforce lists
    if ((userRole === "spclty_hub_hcp_marketer" || 
         userRole === "spclty_hub_omnichannel_advisor" || 
         userRole === "spclty_hub_mlr_reviewer" || 
         userRole === "spclty_hub_mlr_approver") && isSalesforceList) {
      return false;
    }
    
    // not allowing any role for archived lists
    if (specialtyList.list_status === "ARCHIVE") {
      return false;
    }

    // now allowing viewer role any list
    if (userRole === "spclty_hub_viewer" || userRole === "spclty_hub_bia_team") {
      return false;
    }
    
    // not allowing MLR approver and reviewer to edit title and metadata
    // (approver roles should never edit)
    if (
      userRole === "spclty_hub_mlr_approver" ||
      userRole === "spclty_hub_mlr_reviewer" ||
      userRole === "spclty_hub_incentivized_approver"
    ) {
      return false;
    }

    // allowing super admin for all other lists
    if (checkListStatusSuperAdmin()) {
      return true;
    }

    // now allowing other roles for approved lists
    if (specialtyList.list_status === "APPROVED") {
      return false;
    }

    // HCP SF Marketer with shared brand access can edit title/metadata on DRAFT SF lists
    if (specialtyList.list_status === "DRAFT") {
      if (userRole === "spclty_hub_hcp_sf_marketer" && isSalesforceList) {
        return isCreatorOrAdmin() || hasSharedBrandAccess();
      }
      return isCreatorOrAdmin();
    }

    // All other non-approver, non-viewer roles can edit (within their workflow)
    return true;
  };

  const updateCurrentPage = (page) => {
    setCurrentPage(page);
    const start = (page - 1) * pageSize;
    setStart(start);
    setEnd(start + pageSize);
  };
  const checkdisabled = () => {
    const currentStatus = specialtyList?.list_status;
    const isSuperAdmin = userRole === "spclty_hub_super_admin";
    
    // Super Admin has override capability - enable button for all valid workflow statuses
    if (isSuperAdmin) {
      // Disable if editing is in progress
      if (editBrandIndication) {
        return true;
      }
      // Enable for all workflow statuses (DRAFT, REQUEST FOR REVIEW, REQUEST FOR APPROVAL)
      return false;
    }
    
    // Admin CANNOT approve or review - only route from DRAFT
    if (userRole === "spclty_hub_admin") {
      if (currentStatus === "DRAFT") {
        if (editBrandIndication) {
          return true;
        }
        return false;
      }
      // Admin disabled for all review/approval statuses
      return true;
    }
    
    // Handle DRAFT status - only creator can submit for review
    if (currentStatus === "DRAFT") {
      // Handle both object and string formats for created_by
      const creatorUuid = typeof specialtyList.created_by === 'object' 
        ? specialtyList.created_by?.uuid 
        : specialtyList.created_by;
      const isCreator = currentRoleUuid && creatorUuid === currentRoleUuid;
      
      if (!isCreator) {
        return true;
      }
      return false;
    }
    
    // Disable for MLR Approver and Reviewer based on status
    if (userRole === "spclty_hub_mlr_approver") {
      // MLR Approver: disabled in DRAFT and REQUEST FOR REVIEW states
      if (currentStatus === "DRAFT" || currentStatus === "REQUEST FOR REVIEW") {
        return true;
      }
    }
    
    if (userRole === "spclty_hub_mlr_reviewer") {
      // MLR Reviewer: disabled in DRAFT and REQUEST FOR APPROVAL states
      if (currentStatus === "DRAFT" || currentStatus === "REQUEST FOR APPROVAL") {
        return true;
      }
    }
    
    // Check if current user already approved - disable button if they have
    if (
      currentStatus === "REQUEST FOR APPROVAL" &&
      specialtyList?.approversubmitted?.length > 0 &&
      specialtyList?.approversubmitted?.some((item) => useruuids.includes(item))
    ) {
      return true;
    }
    
    // Check if current user already reviewed - disable button if they have
    if (
      currentStatus === "REQUEST FOR REVIEW" &&
      specialtyList?.reviewsubmitted?.length > 0 &&
      specialtyList?.reviewsubmitted?.some((item) => useruuids.includes(item))
    ) {
      return true;
    }
    
    if (
      editBrandIndication ||
      (specialtyList?.list_status === "REQUEST FOR APPROVAL" &&
        specialtyList?.approverlist?.length !== 0 &&
        !specialtyList?.approverlist?.some((item) =>
          useruuids.includes(item)
        )) ||
      (specialtyList?.list_status === "REQUEST FOR REVIEW" &&
        specialtyList?.reviewerlist?.length !== 0 &&
        !specialtyList?.reviewerlist?.some((item) => useruuids.includes(item)))
    ) {
      return true;
    }
    return false;
  };
  return (
    <>
      <LdsCard className="details-card mt-4">
        <LdsCard.Body>
          {CheckViewerRole() && (
            <div>
              <LdsButton onClick={downloadcsv} classes="action compact">
                Export List Data
              </LdsButton>
            </div>
          )}

          {/* ── Lock banner ────────────────────────────────────────────────── */}
          {lockInfo?.locked_by && (
            <div
              className="mt-2 p-2 d-flex align-items-center justify-content-between"
              style={{
                background: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "4px",
              }}
            >
              <span>
                <LdsIcon decorative name="LockClosed" inline />{" "}
                This list is currently being edited by another user.
                {lockInfo.locked_at && (
                  <span className="ml-1 text-muted" style={{ fontSize: "0.85em" }}>
                    (since {new Date(lockInfo.locked_at).toLocaleTimeString()})
                  </span>
                )}
              </span>
              {(userRole === "spclty_hub_admin" || userRole === "spclty_hub_super_admin") && (
                <LdsButton
                  classes="action compact"
                  onClick={handleForceUnlock}
                >
                  Unlock
                </LdsButton>
              )}
            </div>
          )}
          {/* ────────────────────────────────────────────────────────────────── */}
          <>
            <div className="created-txt mt-2 d-flex align-items-center justify-content-between">
              <span>
                {convertDateFormat(specialtyList.updated_date)} | Updated by{" "}
                {getCreateUpdateBy(specialtyList.updated_by)}
              </span>
              {(specialtyList.list_status || "").toUpperCase() !== "APPROVED" &&
                isCreatorOrAdmin() && (
                <LdsIcon
                  inline
                  name="Info"
                  onClick={() => setIsInfoModalOpen(true)}
                  style={{ fontSize: "1.5rem", cursor: "pointer" }}
                />
              )}
            </div>
            <div className="content-block details-heading">
                <div className="row speciality-title">
                  <div className=" col col-md-auto">
                    <h3>{specialtyList.list_title}</h3>
                  </div>
                  <div className="col col-md-auto">
                    <div>
                      <span>
                        <LdsBadge className={`ml-4 ${badgeColourClass()}`}>
                          {specialtyList.list_status}
                        </LdsBadge>
                      </span>
                      <span>
                        <LdsBadge className="ml-4 dept-badges">
                          {specialtyList.department_field === "RETAIL"
                            ? "COMMERCIAL"
                            : "MEDICAL"}
                        </LdsBadge>
                      </span>
                      <span>
                        {specialtyList.list_quarter !== "" && (
                          <LdsBadge className="ml-4 light-green-btn">
                            SALESFORCE
                          </LdsBadge>
                        )}
                      </span>
                      <span>
                        {specialtyList.list_quarter === "" && (
                          <LdsBadge className="ml-4 grey-clr">
                            MLR
                          </LdsBadge>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            {!editBrandIndication && (
              <div className="mrgn-tp-6 details-heading">
                <div className="row speciality-title">
                  <div className="col col-md-auto">
                    <h4 className="brand-indictn-hdng">
                      {specialtyList.list_quarter && (
                        <span> {specialtyList.list_quarter} -</span>
                      )}{" "}
                      {specialtyList.thpc_nm}{" "}
                      {specialtyList.dsst_nm && (
                        <span> - {specialtyList.dsst_nm}</span>
                      )}{" "}
                        {specialtyList.brand_nm && (
                        <span> - {specialtyList.brand_nm}</span>
                      )}{" "}                    
                        {specialtyList.indication_nm && (
                        <span> - {specialtyList.indication_nm}</span>
                      )}{" "}
                        {specialtyList.mdpr_nm && (
                        <span> - {specialtyList.mdpr_nm}</span>
                      )}
                    </h4>
                  </div>
                  {allowToEditTitleAndMetaData() && (
                    <div className="col col-md-auto">
                      <LdsButton
                        linkButton
                        className="edit-title-lnk"
                        onClick={editBrandIndicationTitle}
                        disabled={!!lockInfo?.locked_by || lockLoading}
                      >
                        Edit Meta Data
                      </LdsButton>
                    </div>
                  )}
                </div>
              </div>
            )}
            {editBrandIndication && (
              <EditBrandIndication
                modalType = {checkRoleSFMarketer()}
                closeBrandIndicationEdit={closeBrandIndicationEdit}
                saveMetaData={saveMetaData}
              ></EditBrandIndication>
            )}
            {!checkSpecialtyListLen(visibleSpecialties) && (
              <p className="mt-3"> No Record Found</p>
            )}
            {checkSpecialtyListLen(visibleSpecialties) && (
              <div className="mt-3">
                <div className="row">
                  <div className="col col-6">
                    <LdsSearch
                      id="searchDisabled"
                      className="mt-4 pl-1"
                      name="search_keyword"
                      onChange={(value) => {
                        setsearchText(value);
                        if (value === '') {
                          // Reset search results when field is cleared
                          const tempVisibleSpecialties = JSON.parse(
                            JSON.stringify(visibleSpecialties)
                          );
                          tempVisibleSpecialties.specialties = visibleSpecialties.specialties.map(
                            (s) => ({
                              ...s,
                              show: true,
                            })
                          );
                          setVisibleSpecialties(tempVisibleSpecialties);
                          setTotalPages(
                            Math.ceil(
                              tempVisibleSpecialties.specialties.filter((specialty) => specialty.show)
                                .length / pageSize
                            )
                          );
                          updateCurrentPage(1);
                        }
                      }}
                      value={searchText}
                      onSubmit={filterSpecialityCodeList}
                    />
                  </div>
                  <div className="col col-6">
                    <div className="AddRespBtn">
                      {showAddRespButton() && (
                        <span>
                          <LdsButton
                            className="button-icon-left blue-btn"
                            disabled={!!lockInfo?.locked_by || lockLoading}
                            onClick={() => {
                              showaddMultiResponsibilitiesModal("add");
                            }}
                          >
                            Add Responsibility
                          </LdsButton>
                        </span>
                      )}
                      {showAddRespButton() && (
                        <span>
                          <LdsButton
                            className="button-icon-left blue-btn mx-2"
                            disabled={!!lockInfo?.locked_by || lockLoading}
                            onClick={() => {
                              showaddMultiResponsibilitiesModal("remove");
                            }}
                          >
                            Remove Responsibility
                          </LdsButton>
                        </span>
                      )}
                      {showDeleteButton() && (
                        <span>
                          <LdsButton
                            className="button-icon-left blue-btn"
                            disabled={!!lockInfo?.locked_by || lockLoading}
                            onClick={deleteMultiple}
                          >
                            Delete
                          </LdsButton>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {visibleSpecialties.specialties.filter((specialty) => specialty.show).length === 0 ? (
                  <p className="no-data-message">No data available</p>
                ) : (
                  <>
                <LdsTable
                  id="speciality-list-table"
                  flat
                  className="stl-table-list"
                  layoutClass="layout-auto"
                >
                  <thead>
                    <tr className="align-left">
                      {checkListStatus() && (
                        <th style={{ width: "12ch", verticalAlign: "middle" }}>
                          <LdsLink
                            onClick={() =>
                              selectAllSpecialties(selectOrUnselect())
                            }
                          >
                            {selectOrUnselect()}
                          </LdsLink>
                        </th>
                      )}
                      <SortableHeader
                        headAlign={"align-left b"}
                        header={getTableColumn()}
                        rowData={visibleSpecialties.specialties}
                        rowKeyName={[
                          "specialty_code",
                          "specialty_description",
                          "incentivized",
                          "responsibility_code",
                        ]}
                        sortedRowData={(data) => {
                          const tempVisibleSpecialties = JSON.parse(
                            JSON.stringify(visibleSpecialties)
                          );
                          tempVisibleSpecialties.specialties = data;
                          setVisibleSpecialties(tempVisibleSpecialties);
                        }}
                      />
                    </tr>
                  </thead>
                  <tbody>
                    {visibleSpecialties.specialties &&
                      visibleSpecialties.specialties
                        .filter((specialty) => specialty.show)
                        .map(
                          (aTable, index) =>
                            index >= start &&
                            index < end && (
                              <tr
                                id={aTable.specialty_code}
                                key={aTable.specialty_code}
                                className="align-left"
                              >
                                {checkListStatus() && (
                                  <td>
                                    <LdsCheckbox
                                      id={"selected-" + index}
                                      required={false}
                                      name={"selected-" + index}
                                      disabled={!checkListStatus()}
                                      checked={aTable.selectedSpecialty === true}
                                      value={aTable.specialty_code}
                                      onChange={(event) =>
                                        selcheckBoxClicked(event, aTable)
                                      }
                                    />
                                  </td>
                                )}
                                <td>{aTable.specialty_code}</td>
                                <td>{aTable.specialty_description}</td>
                                {!checkOmniOrHCPOrMLRRole() && (
                                  <td>
                                    {checkListStatus() && (
                                      <LdsCheckbox
                                        id={"incentivized-" + index}
                                        required={false}
                                        name={"incentivized-" + index}
                                        disabled={!checkListStatus() || !!lockInfo?.locked_by}
                                        checked={aTable.incentivized === true}
                                        value={aTable.specialty_code}
                                        onChange={(event) =>
                                          incvcheckBoxClicked(event, aTable)
                                        }
                                      />
                                    )}
                                    {aTable.incentivized ? "Yes" : "No"}
                                  </td>
                                )}
                                {!checkOmniOrHCPOrMLRRole() && (
                                  <td>{respCodeContent(aTable)}</td>
                                )}
                                {!checkOmniOrHCPOrMLRRole() && (
                                  <td>
                                    {checkListStatus() &&
                                      aTable.incentivized && (
                                        <LdsButton
                                          linkButton
                                          disabled={!!lockInfo?.locked_by || lockLoading}
                                          onClick={() =>
                                            showSearchResponsibilityModal(
                                              aTable
                                            )
                                          }
                                        >
                                          Select responsibility
                                        </LdsButton>
                                      )}
                                  </td>
                                )}
                                <td className="i-action delete-sp">
                                  {checkListStatus() &&
                                    showDeleteButton() &&
                                    !lockInfo?.locked_by && (
                                      <span
                                        onClick={() => {
                                          deleteSpecialityList(aTable);
                                        }}
                                      >
                                        <LdsIcon
                                          description="Delete the speciality list.."
                                          label="Delete Speciality list"
                                          name="TrashSimpleFill"
                                          inline
                                        />
                                      </span>
                                    )}
                                </td>
                              </tr>
                            )
                        )}
                  </tbody>
                </LdsTable>
                <LdsPagination
                  currentPage={currentPage}
                  setCurrentPage={updateCurrentPage}
                  totalPages={totalPages}
                  className="mt-4"
                />
                </>
                )}
              </div>
            )}
          </>
        </LdsCard.Body>
        <LdsCard.Footer>
        {specialtyList.reviewerlist &&   <div><br></br>
            <span><b>Reviewer List:</b></span>
            <ul>{specialtyList.reviewerlist.map((value,index)=>{return <li key={`reviewer-${index}-${value}`} style={{listStyleType: "none"}}><span>&nbsp;<b style={{color: specialtyList.reviewsubmitted.includes(value) ?  "#31855b" : null}}>{userTableList.find((elm)=> elm.uuid === value)?.email_id}</b>&nbsp;</span></li>})}</ul>
          </div>}
          {specialtyList.approverlist &&   <div><br></br>
            <span><b>Approver List:</b></span>
            <ul>{specialtyList.approverlist.map((value,index)=>{return <li key={`approver-${index}-${value}`} style={{listStyleType: "none"}}><span>&nbsp;<b style={{color: specialtyList.approversubmitted?.includes(value) ?  "#31855b" : null}}>{userTableList.find((elm)=> elm.uuid === value)?.email_id}</b>&nbsp;</span></li>})}</ul>
          </div>}
          {(userRole === "spclty_hub_admin" || userRole === "spclty_hub_super_admin") &&
            (specialtyList.list_status === "REQUEST FOR REVIEW" || specialtyList.list_status === "REQUEST FOR APPROVAL") &&
            (specialtyList.reviewerlist || specialtyList.approverlist) && (
              <div style={{ marginTop: "12px" }}>
                <LdsButton
                  linkButton
                  onClick={() => setIsEditParticipantsOpen(true)}
                >
                  <LdsIcon name="PencilSimpleFill" inline /> Edit Reviewers/Approvers
                </LdsButton>
              </div>
            )}
        </LdsCard.Footer>
      </LdsCard>
      <div className="row">
        <div className="col">
          {showSubmitDraftButtons() && (
            <div className="savecl">
              {userRole !== "spclty_hub_incentivized_approver" && (
                <LdsButton
                  className={`button-icon-right ${
                    editBrandIndication ? "" : "blue-bdr-btn"
                  }`}
                  disabled={
                    editBrandIndication ||
                    userRole === "spclty_hub_mlr_reviewer" ||
                    userRole === "spclty_hub_mlr_approver" ||
                    !!lockInfo?.locked_by || lockLoading
                  }
                  onClick={DraftSpecialityDetails}
                >
                  Save Draft
                </LdsButton>
              )}
              <span className="ml-4">
                <LdsButton
                  className={`button-icon-right mt-4 ${checkEditTitle()}`}
                  disabled={checkdisabled() || !!lockInfo?.locked_by || lockLoading}
                  onClick={confirmSubmission}
                >
                  {userRole === "spclty_hub_super_admin"
                    ? "Approve Direct"
                    : checkIncentivisedList(specialtyList || "", userRole) &&
                      specialtyList.list_status === "REQUEST FOR APPROVAL"
                    ? "Approve"
                    : "Submit"}
                </LdsButton>
              </span>
            </div>
          )}
          <div className="button-icon-right margin-saved">
            <div className="list-info-card">
              {/* Created By Section */}
              <div className="info-section">
                <div className="info-label">Created By</div>
                <div className="info-content">
                  <span className="name-text creator">
                    {getCreateUpdateBy(specialtyList.created_by || "")}
                  </span>
                  <span className="separator">•</span>
                  <span className="date-text">
                    {convertDateFormat(specialtyList.created_date || "")}
                  </span>
                </div>
              </div>

              {/* Approval Information - Only shown when list is approved */}
              {specialtyList.list_status === "APPROVED" && (
                <>
                  {/* Approved By Section */}
                  <div className="info-section">
                    <div className="info-label">
                      <LdsIcon name="CheckCircleFill" inline className="check-icon" />
                      Approved By
                    </div>
                    <div className="info-content">
                      {specialtyList.approverlist && specialtyList.approverlist.length > 0 ? (
                        <>
                          <span className="name-text approver">
                            {specialtyList.approverlist.map((value, index) => {
                              const user = userTableList.find((elm) => elm.uuid === value);
                              return (
                                <span key={index}>
                                  {index > 0 && ", "}
                                  {user?.first_name} {user?.last_name}
                                </span>
                              );
                            })}
                          </span>
                          <span className="separator">•</span>
                          <span className="date-text">
                            {convertDateFormat(specialtyList.approved_date || "")}
                          </span>
                        </>
                      ) : (
                        <span className="na-text">N/A</span>
                      )}
                    </div>
                  </div>

                  {/* Expiration Date Section - Highlighted */}
                  <div className="expiration-section">
                    <div className="expiration-label">⏰ Expiration Date</div>
                    <div className="expiration-date">
                      {convertDateFormat(specialtyList.expiration_date || "")}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <ListApprovedModal
          isListAppModalOpen={isListAppModalOpen}
          setListAppModalOpen={setListAppModalOpen}
          msg={msg}
          setMsg={setMsg}
          updateSpecialityDetails={updateSpecialityDetails}
          addedSpecialtyCodes={addedSpecialtyCodes}
          uncommonRespCodes={uncommonRespCodes}
          delSpecialtyCodes={delSpecialtyCodes}
          department={specialtyList.department_field}
          quarter={specialtyList.list_quarter}
          currentRoleUuid={currentRoleUuid}
        ></ListApprovedModal>
      </div>
      <SearchResponsibilityModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        responsibilitylist={responsibilityList.map((itm) => ({
          ...itm,
          show: true,
        }))}
        specialtylist={visibleSpecialties}
        indexlst={updateResCodeIndex}
        updateSelectedResponsibility={updateSelectedResponsibility}
        onCancel={unlockList}
      ></SearchResponsibilityModal>
      <AddMultiRespModal
        isRespModalOpen={isRespModalOpen}
        setIsRespModalOpen={setIsRespModalOpen}
        updateMultiSelectedResponsibility={updateMultiSelectedResponsibility}
        selectedValues={selectedValues}
        respmode={respmode}
        visibleSpecialties={visibleSpecialties}
        onCancel={unlockList}
      ></AddMultiRespModal>
      <ConfirmDeleteModal
        isDelModalOpen={isDelModalOpen}
        setIsDelModalOpen={setIsDelModalOpen}
        confirmDelete={confirmDelete}
      ></ConfirmDeleteModal>
      <EditParticipantsModal
        isOpen={isEditParticipantsOpen}
        setIsOpen={setIsEditParticipantsOpen}
        specialtyList={specialtyList}
        onSave={handleSaveParticipants}
      />
      {isInfoModalOpen && (
        <LdsModal
          modalId="list-status-info-modal"
          open={isInfoModalOpen}
          setModalOpen={setIsInfoModalOpen}
          title=""
          style={{ paddingTop: "4.9rem" }}
        >
          <div style={{ marginTop: "0.35rem", minHeight: "200px" }}>
            <h3 style={{ marginBottom: "2.8rem" }}>
              <span><b>Current Status:</b></span>{" "}
              {(specialtyList.list_status || "").toLowerCase().replace(/\b\w/g, c => c.toUpperCase())}
            </h3>
            <StepTracker
              listType={specialtyList.list_quarter !== "" ? "SALESFORCE" : "MLR"}
              currentStatus={specialtyList.list_status}
              onRemind={handleRemind}
              isCooldownActive={isCooldownActive}
              specialtyList={specialtyList}
              userTableList={userTableList}
            />
          </div>
        </LdsModal>
      )}

      {/* ── end modals   */} 
    </>
  );
};

export default OverviewTable;
